import { useIntl } from 'react-intl';
import { NextSeo } from 'next-seo';

import { navigationMessages } from '@/core/messages/navigation.messages';

import { Search } from '@/features/Search';

const Page = () => {
  const { formatMessage } = useIntl();

  return (
    <>
      <NextSeo
        title={formatMessage(navigationMessages.search)}
      />

      <Search />
    </>
  );
};

Page.hideFooter = true;
Page.hideNavigation = true;

export default Page;
